// FILE: /src/store/Slices/CalendarFilterSlice.js (FULLY UPDATED)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosServices from '../../services/axios';
import moment from 'moment';

export const fetchCalendarPosts = createAsyncThunk(
    'calendar/fetchPosts',
    async (filters, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post('/calendar/all-posts', filters);
            return response.data.posts;
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch calendar data';
            console.error('[Thunk: fetchCalendarPosts] API Error:', errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

export const triggerUserSync = createAsyncThunk(
    'calendar/triggerSync',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post('/calendar/run-sync');
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to refresh data.';
            return rejectWithValue(errorMessage);
        }
    }
);

const initialState = {
    posts: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    syncStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    syncError: null,
    filters: {
        dateRange: {
            start: moment().startOf('month').toISOString(),
            end: moment().endOf('month').toISOString(),
        },
        platforms: ["FACEBOOK", "INSTAGRAM", "PINTEREST"],
        profiles: [], 
        postTypes: ["Image", "Video"],
        statuses: ["Published", "Scheduled", "Drafts", "Failed", "Processing"],
        authorId: null,
    },
};

const calendarFilterSlice = createSlice({
    name: 'calendarFilter',
    initialState,
    reducers: {
        setCalendarFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        setDateRange(state, action) {
            state.filters.dateRange = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCalendarPosts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCalendarPosts.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.posts = action.payload;
            })
            .addCase(fetchCalendarPosts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(triggerUserSync.pending, (state) => {
                state.syncStatus = 'loading';
                state.syncError = null;
            })
            .addCase(triggerUserSync.fulfilled, (state) => {
                state.syncStatus = 'succeeded';
            })
            .addCase(triggerUserSync.rejected, (state, action) => {
                state.syncStatus = 'failed';
                state.syncError = action.payload;
            });
    },
});

export const { setCalendarFilters, setDateRange } = calendarFilterSlice.actions;

export default calendarFilterSlice.reducer;